/* Vorher/Nachher-Schieber, uebernommen aus Ellis-Kueche-Presell.html.
   Gleiche Logik: clip-path am oberen Bild, Ziehen ueber Pointer-Events,
   Startposition 65 %. Zusaetzlich Tastaturbedienung, weil die Section auf
   der Produktseite auch ohne Zeigegeraet erreichbar sein muss. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.smeluPhInit === '1') return;
    root.dataset.smeluPhInit = '1';

    var c = root.querySelector('[data-smelu-ph-cx]');
    if (!c) return;
    var top = c.querySelector('[data-smelu-ph-top]');
    var div = c.querySelector('[data-smelu-ph-div]');
    var hint = c.querySelector('[data-smelu-ph-hint]');
    var drag = false, pos = 65;

    function set(x) {
      pos = Math.max(0, Math.min(100, x));
      top.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      div.style.left = pos + '%';
      c.setAttribute('aria-valuenow', Math.round(pos));
    }
    function px(e) {
      var r = c.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      set((cx - grabDx - r.left) / r.width * 100);
    }
    /* Der Schieber startet nur am Griff, nicht irgendwo auf dem Bild. Sonst
       springt die Trennlinie bei jedem Tippen auf die Klickstelle, und das
       Bild laesst sich auf dem Handy nicht mehr ansehen, ohne es zu verstellen.
       Beim Anfassen wird der Abstand zwischen Zeigerposition und Trennlinie
       gemerkt, damit die Linie nicht unter den Finger schnappt. */
    var grabDx = 0;

    function start(e) {
      var r = c.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      grabDx = cx - (r.left + r.width * pos / 100);
      drag = true;
      if (hint) hint.style.opacity = 0;
      if (div.setPointerCapture && e.pointerId != null) {
        try { div.setPointerCapture(e.pointerId); } catch (x) {}
      }
      e.preventDefault();
    }

    div.addEventListener('pointerdown', start);
    div.addEventListener('pointermove', function (e) { if (drag) px(e); });
    window.addEventListener('pointermove', function (e) { if (drag) px(e); }, { passive: true });
    window.addEventListener('pointerup', function () { drag = false; });
    window.addEventListener('pointercancel', function () { drag = false; });

    c.setAttribute('role', 'slider');
    c.setAttribute('tabindex', '0');
    c.setAttribute('aria-label', 'Vorher-Nachher-Schieber');
    c.setAttribute('aria-valuemin', '0');
    c.setAttribute('aria-valuemax', '100');
    c.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { set(pos - 4); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { set(pos + 4); e.preventDefault(); }
      else return;
      if (hint) hint.style.opacity = 0;
    });

    set(65);
  }
  function boot() { document.querySelectorAll('[data-smelu-ph]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
